import { useEffect, useState } from "react";
import { SortOrder } from "primereact/api";
import findFranquia from "../service/findFranquia";

/**
 * Cache em memória compartilhado por todos os componentes que precisam da lista
 * de franquias. A lista é grande e praticamente estática, então fica fora do
 * estado global (que é serializado no localStorage a cada alteração).
 */
let franquiasCache: any[] | null = null;
let franquiasRequest: Promise<any[]> | null = null;

const lazyFranquia = {
  first: 0,
  rows: 9999,
  page: 1,
  franquia: null,
  documento: null,
  sortField: 'nome',
  sortOrder: SortOrder.DESC
};

/** Carrega as franquias uma única vez; chamadas simultâneas reaproveitam a mesma requisição. */
const carregarFranquias = (): Promise<any[]> => {
  if (franquiasCache) {
    return Promise.resolve(franquiasCache);
  }
  if (!franquiasRequest) {
    franquiasRequest = findFranquia(lazyFranquia)
      .then((data) => {
        franquiasCache = data.franquias || [];
        return franquiasCache as any[];
      })
      .catch(() => {
        franquiasRequest = null; // libera para uma nova tentativa
        return [];
      });
  }
  return franquiasRequest;
};

/** Invalida o cache, forçando uma nova busca no próximo uso (ex.: após cadastrar franquia). */
const limparCacheFranquias = () => {
  franquiasCache = null;
  franquiasRequest = null;
};

const useFranquias = () => {
  const [franquias, setFranquias] = useState<any[]>(franquiasCache || []);
  const [loading, setLoading] = useState(!franquiasCache);

  useEffect(() => {
    if (franquiasCache) {
      return;
    }
    let ativo = true;
    carregarFranquias().then((data) => {
      if (!ativo) {
        return;
      }
      setFranquias(data);
      setLoading(false);
    });
    return () => { ativo = false; };
  }, []);

  return { franquias, loading };
};

export default useFranquias;
export { carregarFranquias, limparCacheFranquias };
